module.exports = __webpack_public_path__ + "img/promoted.1ae68365.jpg";